
import { defineComponent } from 'vue'
import { BillNewDto } from '@/api/bill'
import { getEnsureCostListapi, exportBillList, getInsureEnsurePlanListApi } from '@/api/long-insure'
import { shortcutsNew } from '@/utils/global'
import { downLoadBlob } from '../utils/util'
import { ElMessage } from 'element-plus'
import dayjs from 'dayjs'
export default defineComponent({
  name: 'LontInsureBill',
  data() {
    return {
      form: {
        type: '1',
        filterDate: dayjs().format('YYYY-MM') as string,
        ensurePlanId: undefined
      },
      ensurePlanList: [] as any[],
      isUp: false,
      tableData: [] as BillNewDto[], // 如同BillDto的数据
      filterDate: [] as string[],
      pageSize: 10, // 每页显示十条
      pageNum: 1, // 页数为1
      total: 0, // 总的为0
      shortcuts: shortcutsNew,
      payDateSolt: '',
      totalValue1: 0 as number,
      totalValue2: 0 as number,
      totalValue3: 0 as number,
      totalValue4: 0 as number,
      activeTab: '' as string,
      tabList1: [
        { label: '今天', name: 1 },
        { label: '昨天', name: 2 },
        { label: '本周', name: 3 },
        { label: '上周', name: 4 },
        { label: '本月', name: 5 },
        { label: '上月', name: 6 }
      ],
      tabList2: [
        { label: '本月', name: 5 },
        { label: '上月', name: 6 }
      ]
    }
  },
  async created() {
    this.filterDate = [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
    const plans = await getInsureEnsurePlanListApi({ insureType: 2 })
    this.ensurePlanList = plans || []
    this.getBongBillRecord()
  },
  methods: {
    onCancel() {
      this.isUp = false
      this.form.type = '1'
      this.form.ensurePlanId = ''
      this.activeTab = '1'
      this.form.filterDate = dayjs().format('YYYY-MM')
    },
    async onSure() {
      console.log(this, 'onSure 导出')
      if (this.form.type === '' || this.form.type === null) {
        ElMessage({
          message: '请选择账单类型',
          type: 'warning'
        })
        return false
      }
      if (!this.form.filterDate) {
        ElMessage({
          message: '请选择账单时间',
          type: 'warning'
        })
        return false
      }
      const queryStart = dayjs(this.form.filterDate).startOf('month').format('YYYY-MM-DD')
      const queryEnd = dayjs(this.form.filterDate).endOf('month').format('YYYY-MM-DD')
      if (this.form.type == '1') {
        let res = await exportBillList(
          {
            queryStart,
            queryEnd,
            ensurePlanId: this.form.ensurePlanId || undefined
          },
          '/staff'
        )
        downLoadBlob(res, `安心保【${this.form.filterDate}】人员账单`)
        this.$message.success('导出成功！')
        this.onCancel()
      }
      if (this.form.type == '2') {
        let res = await exportBillList(
          {
            queryStart,
            queryEnd,
            ensurePlanId: this.form.ensurePlanId || undefined
          },
          '/billList'
        )
        downLoadBlob(res, `安心保【${this.form.filterDate}】账单明细`)
        this.$message.success('导出成功！')
        this.onCancel()
      }
    },

    // tab类型变化
    onTabChange(val: any) {
      // 日期组件赋值
      console.log(val, this.form.type, 'tab类型变化，日期组件赋值')
      const now = dayjs()
      let startDate = ''
      let endDate = ''

      switch (val) {
        case 1:
          // 今天
          startDate = now.format('YYYY-MM-DD')
          endDate = now.format('YYYY-MM-DD')
          break
        case 2:
          // 昨天
          startDate = now.subtract(1, 'day').format('YYYY-MM-DD')
          endDate = now.subtract(1, 'day').format('YYYY-MM-DD')
          break
        case 3:
          // 本周
          const date = now.subtract(now.day() - 1, 'day').startOf('day')
          startDate = date.format('YYYY-MM-DD')
          endDate = date.add(6, 'day').endOf('day').format('YYYY-MM-DD')
          break
        case 4:
          // 上周
          let date1 = now.subtract(now.day() - 1, 'day').startOf('day')
          date1 = date1.subtract(1, 'week').startOf('day')
          startDate = date1.format('YYYY-MM-DD')
          endDate = date1.add(6, 'day').endOf('day').format('YYYY-MM-DD')
          break
        case 5:
          // 本月
          startDate = now.startOf('month').format('YYYY-MM-DD')
          endDate = now.endOf('month').format('YYYY-MM-DD')
          break
        case 6:
          // 上月
          startDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
          endDate = now.subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
          break
      }

      this.form.filterDate = [startDate, endDate]
    },

    // 账单类型变化
    onTypeChange(val: any) {
      // 重置tab筛选
      if (val == '1') {
        this.activeTab = '1'
        this.form.filterDate = dayjs().format('YYYY-MM')
      } else {
        this.activeTab = '5'
        this.form.filterDate = dayjs().format('YYYY-MM')
      }
    },

    onMonth() {
      this.getBongBillRecord()
    },
    changeFilterDate(e: any) {
      console.log(e, 'eeeeeeee')
      this.getBongBillRecord()
    },
    onChangeDate(e: any) {
      console.log(e, 'eeeeeeee')
    },
    onShowpopup() {
      console.log('打开导出弹框')
      this.isUp = true
    },
    async getBongBillRecord() {
      const result = await getEnsureCostListapi({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        queryStart: this.filterDate[0],
        queryEnd: this.filterDate[1]
      })
      console.log(result, 'result')
      this.total = result.totalCount
      this.tableData = result.list
      let value1 = 0
      let value2 = 0
      let value3 = 0
      let value4 = 0
      result.list.forEach((_: BillNewDto) => {
        console.log(_, 'result.list.forEach')

        value1 = value1 + Number(_.realPay)
        value2 = value2 + Number(_.totalInsuranceFee)
        value3 = value3 + Number(_.increaseInsuranceFee)
        value4 = value4 + Number(_.membershipCardDeduction)
      })
      this.totalValue1 = Number(value1.toFixed(2))
      this.totalValue2 = Number(value2.toFixed(2))
      this.totalValue3 = Number(value3.toFixed(2))
      this.totalValue4 = Number(value4.toFixed(2))
    },
    handleSizeChange() {
      this.pageNum = 1
      this.getBongBillRecord()
    }
  }
})
